module.exports = __webpack_public_path__ + "static/img/img5.eff4b23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img5.png
// module id = QeSs
// module chunks = 0